import { render, staticRenderFns } from "./AddTupleToList.vue?vue&type=template&id=63043936"
import script from "./AddTupleToList.vue?vue&type=script&lang=js"
export * from "./AddTupleToList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports